import { stencil } from 'react-common'
import { useSidebarLayers } from '@/features/layout/hooks/useSidebarLayers'
import { SideBarItem } from './SideBarItem'
import { getItemKey } from './utils'
import { useStencilNavigation } from '../useStencilNavigation'

const { SideBarPlugin } = stencil

export const SideBarPluginContainer = () => {
  const { activeSlug } = useStencilNavigation()
  const { sidebarLayers } = useSidebarLayers()

  return (
    <SideBarPlugin asContainer="ul">
      {sidebarLayers?.map((item, index) => (
        <li key={getItemKey(item, index)}>
          <SideBarItem item={item} activeSlug={activeSlug} />
        </li>
      ))}
    </SideBarPlugin>
  )
}
